import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_94_756",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_94_756)" }, [
      _createElementVNode("path", {
        d: "M8.33332 13.4327L5.29645 10.3958L6.06249 9.62978L8.33332 11.9006L13.9375 6.29645L14.7035 7.06249L8.33332 13.4327Z",
        fill: "#5983B6"
      })
    ], -1)
  ])))
}
export default { render: render }